import { ErrorHandler, Injectable } from "@angular/core"
import { captureException } from "@sentry/angular-ivy"
import { addBreadcrumb, setTag } from "@sentry/browser"
import { environment } from "@env/environment"
import { Router } from "@angular/router"

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor(private router: Router) {}

  handleError(error: any): void {
    // Normalize the error: Angular's ErrorHandler can receive Error objects,
    // raw objects (e.g. {error: ...} from HTTP interceptors), or strings.
    // Sentry's captureException needs a proper Error/string to group correctly.
    let normalizedError: any = error

    if (error && typeof error === 'object' && !(error instanceof Error)) {
      // Unwrap nested { error: ... } objects (common with RxJS/HttpInterceptor)
      if (error.error && typeof error.error === 'object' && error.error.message) {
        normalizedError = new Error(error.error.message)
      } else if (error.message) {
        normalizedError = new Error(error.message)
      } else {
        // Fallback: stringify non-Error objects so Sentry can group them
        try {
          normalizedError = new Error(JSON.stringify(error).substring(0, 500))
        } catch (e) {
          normalizedError = new Error('Unknown non-Error object thrown')
        }
      }
    } else if (typeof error === 'string') {
      normalizedError = new Error(error)
    }

    const errorMsg = normalizedError?.message || normalizedError?.error?.message || "Unknown error"

    if (environment.production) {
      const orgId = localStorage.getItem('account_id')  || 'not-found'
      const userId = localStorage.getItem('User')  || 'not-found'

      addBreadcrumb({
        category: "error",
        message: errorMsg,
        level: "error",
        data: {
          url: this.router.url,
          orgId: orgId || 'not-found',
          userId: userId || 'not-found',
        },
      })

      setTag('organization_id', orgId)
      setTag('user_id', userId)

      captureException(normalizedError)
    } else {
      // In development, log the error to the console
      console.error("Captured by SentryErrorHandler:", normalizedError)
    }
  }
}